<template>
    <ModalBase
        :name="'pagar-plazo-' + plazoId"
        title="Confirmar Pago"
        @close="handleClose"
    >
        <div class="tw:space-y-4">
            <p class="tw:text-sm tw:text-gray-700">
                ¿Estás seguro de que deseas proceder con el pago?
            </p>

            <div class="tw:bg-gray-50 tw:border tw:border-gray-200 tw:rounded-lg tw:p-4 tw:space-y-2">
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">ID del plazo:</span>
                    <span class="tw:text-sm tw:text-gray-900">{{ plazoId }}</span>
                </div>
                <div class="tw:flex tw:justify-between">
                    <span class="tw:text-sm tw:font-medium tw:text-gray-700">Importe:</span>
                    <span class="tw:text-sm tw:text-gray-900">{{ importe | formatear_precio }}</span>
                </div>
            </div>

            <div>
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-2">
                    Método de pago
                </label>
                <BaseMultiselect
                    v-model="selectedMethod"
                    label="Método de pago"
                    :options="metodosPago"
                    labelKey="nombre"
                    valueKey="id"
                />
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:gap-2 tw:justify-end">
                <Button variant="border" @click="handleClose">
                    Cancelar
                </Button>
                <Button
                    variant="primary"
                    :disabled="!selectedMethod"
                    @click="handleConfirm"
                >
                    Pagar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue'
    import store from '@/store'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'

    const props = defineProps({
        importe: {
            type: Number,
            required: true
        },
        plazoId: {
            type: [Number, String],
            required: true
        }
    })

    const emit = defineEmits(['pagar-plazo', 'close'])

    const instance = getCurrentInstance()

    const metodosPago = computed(() => {
        const metodos = store.getters.getTeatro?.metodos_pago_abonos_bases || []
        return metodos.filter(m => ![5, 8, 9].includes(m.id))
    })

    const selectedMethod = ref('')

    const handleConfirm = () => {
        if (selectedMethod.value) {
            emit('pagar-plazo', {
                metodoId: selectedMethod.value,
                plazo_id: props.plazoId
            })
            handleClose()
        }
    }

    const handleClose = () => {
        selectedMethod.value = ''
        instance.proxy.$modal.hide('pagar-plazo-' + props.plazoId)
        emit('close')
    }
</script>
